import { SeoHead } from "@/components/SeoHead";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="服務條款"
        description="閱讀 Skoltend 的服務條款，了解使用香港學校招標資訊平台的相關規定、訂閱政策及用戶責任。"
        canonical="/terms"
      />
      <div className="border-b bg-secondary/30 py-8">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl">
          <h1 className="text-2xl font-bold mb-1">服務條款</h1>
          <p className="text-muted-foreground text-sm">最後更新：2025 年 5 月</p>
        </div>
      </div>
      <div className="container mx-auto px-4 md:px-8 py-10 max-w-3xl space-y-8 text-sm leading-relaxed text-foreground">

        <section className="space-y-3">
          <h2 className="text-base font-semibold">1. 接受條款</h2>
          <p>
            歡迎使用 Skoltend（「本平台」）。本平台由香港學校招標資訊服務提供，網址為
            <strong> www.skoltend.com</strong>。使用本平台即表示您同意受以下服務條款約束。如您不同意本條款，請勿使用本平台。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">2. 服務說明</h2>
          <p>
            Skoltend 是一個香港學校招標資訊匯集平台，收集及整理香港各學校發出的招標及投標資訊，並提供分類篩選、地區篩選及通知功能。
          </p>
          <p>本平台提供兩種會籍：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li><strong>免費會員</strong>：可瀏覽招標標題、截止日期、地區及類別</li>
            <li><strong>付費會員</strong>：可查看學校名稱、聯絡資料，並接收電郵及 Telegram 招標通知</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">3. 帳戶註冊</h2>
          <p>
            使用本平台需透過 Google 帳戶或電郵地址進行註冊。您有責任妥善保管帳戶登入資料，並對您帳戶下的所有活動負責。如發現任何未經授權使用，請立即通知我們。
          </p>
          <p>
            本平台保留拒絕、暫停或終止任何帳戶的權利，尤其是違反本條款的情況。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">4. 付費會員及訂閱</h2>
          <p>付費會員訂閱費用如下：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li>年費計劃：HK$5,888 / 年，按年自動續費</li>
          </ul>
          <p>
            所有付款均透過 Stripe 安全處理。訂閱將於到期日自動續費，除非您在到期日前取消。您可隨時透過會員控制台（Dashboard）取消訂閱，取消後仍可使用服務至當前計費週期結束。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">5. 退款政策</h2>
          <p>
            由於招標資訊為即時更新的數位內容，所有費用概不退還。如您對帳單有疑問，請於付款後 7 日內聯絡我們，我們將按個別情況處理。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">6. 資訊準確性免責聲明</h2>
          <p>
            本平台所提供的招標資訊均由公開渠道收集整理，本平台盡力確保資訊的準確性，但不保證資訊的完整性、及時性或準確性。招標資訊可能因學校更新而有所變動，用戶在作出任何商業決定前，應自行向相關學校核實最新資料。
          </p>
          <p>
            本平台對因使用或依賴本平台資訊而造成的任何損失或損害，概不負責。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">7. 使用限制</h2>
          <p>您同意不會：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li>以自動化方式（包括爬蟲、機器人等）大量抓取本平台資料</li>
            <li>將本平台資料轉售、轉發或用於商業目的，而未獲本平台書面授權</li>
            <li>嘗試破壞、入侵或干擾本平台的正常運作</li>
            <li>創建多個帳戶以規避付費限制</li>
            <li>分享帳戶登入資料予他人共用</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">8. 知識產權</h2>
          <p>
            本平台的設計、標誌、軟件及原創內容受版權法保護，所有權利由 Skoltend 保留。招標資訊本身為各學校的公開資料，本平台對資料的匯集、整理及呈現方式擁有版權。
          </p>
          <p>
            未經書面許可，不得複製、散佈或以其他方式使用本平台的內容。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">9. 服務暫停及終止</h2>
          <p>
            本平台保留因維護、升級或其他原因暫時中斷服務的權利，並會在可能的情況下提前通知。本平台亦保留在不作事先通知的情況下，因違反本條款而終止用戶帳戶的權利。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">10. 條款變更</h2>
          <p>
            本平台可能不定期修訂本服務條款。重大變更將透過電郵或平台通知告知用戶。在通知發出後繼續使用本平台，即視為您接受修訂後的條款。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">11. 適用法律</h2>
          <p>
            本服務條款受香港特別行政區法律管轄，並依照香港法律詮釋。因本條款引起的任何爭議，雙方同意受香港法院的專屬管轄。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">12. 聯絡我們</h2>
          <p>如您對本服務條款有任何疑問，請電郵至：</p>
          <p>
            <a href="mailto:cs@skoltend.com" className="text-primary hover:underline font-medium">
              cs@skoltend.com
            </a>
          </p>
        </section>

      </div>
    </div>
  );
}
